import { ZodArrayToEnum } from '@axiom/types';
import { z } from 'zod';

export const TopTaskCategoriesConst = {
  SubmissionNeeded: 'Submission Needed',

  TalentNearingIdle: 'Talent Nearing Idle',

  TalentCheckIn: 'Talent Check-In',
  TalentCooling: 'Talent Cooling',

  TalentBioIssues: 'Talent Bio Issues',

  TalentFeedback: 'Talent Feedback',

  TalentOnboarding: 'Talent Onboarding',
} as const;

export const TopTaskCategoriesConstKeys = Object.keys(TopTaskCategoriesConst);
export const TopTaskCategoriesConstValues = Object.values(
  TopTaskCategoriesConst
);

export const TopTaskCategorySchema = z.object({
  displayName: z.enum(ZodArrayToEnum(TopTaskCategoriesConstValues)),
  name: z.enum(ZodArrayToEnum(TopTaskCategoriesConstKeys)),
});

export type TopTaskCategory = z.infer<typeof TopTaskCategorySchema>;
